import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

import { FONTS, SPACES } from 'src/constants'

export const useStyles = makeStyles((theme: Theme) => ({
  modal: {
    padding: SPACES.xl,
    minWidth: 400,
    maxWidth: 'calc(100vw - 60px)',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: SPACES.m,
  },
  formTitle: {
    '&&': {
      fontSize: FONTS.SIZES.xxl,
      fontWeight: FONTS.WEIGHTS.bold,
    },
  },
}))
